import { TableCell, TableRow } from "@mui/material";
import { headerCellStyle } from "./CsvReadingResultTableStyles";

export default function CsvReadingResultHeaderRow () {
   
    return (    
      <TableRow>
        <TableCell sx={headerCellStyle}>注文追加</TableCell>
        <TableCell sx={headerCellStyle}>店舗</TableCell>
        <TableCell sx={headerCellStyle}>品名</TableCell>
        <TableCell sx={headerCellStyle}>産地</TableCell>
        <TableCell sx={headerCellStyle}>等級</TableCell>
        <TableCell sx={headerCellStyle}>階級</TableCell>
        <TableCell sx={headerCellStyle}>荷姿</TableCell>
        <TableCell sx={headerCellStyle}>重量</TableCell>
        <TableCell sx={headerCellStyle}>入数</TableCell>
        <TableCell sx={headerCellStyle}>価格</TableCell>
        <TableCell sx={headerCellStyle}>数量</TableCell>
        <TableCell sx={headerCellStyle}>出荷日</TableCell>
      </TableRow>
    )
}